export const mx = {
    'imgUrl': '/country/mexico/luck-draw',

    'drawsTitle': 'Numero de sorteos:',

    'hasPrize': 'Enhorabuena',

    'noPrize': ' ', // Ups！ Mala suerte

    'inviteMsg': 'invitar a amigos',

    'inviteCode': 'Mi código de invitación',

    'copySuccess': 'Se copió correctamente',

    'copy': 'Copiar',

    'title': 'Ruleta navideña',

    'waitLucky': 'En la lotería, espera un momento', // 等待抽奖是的提示

    'prizeRecords': 'Récords de premios',

    'prizeRulesTitle': 'Regla de actividad',

    'numNote': '¿Cómo conseguir sorteos de la suerte?',

    'inviteBtnMsg': 'INVITA AHORA',

    'modelContent' : (count) => `
        <ol>
            <b><li>Solicite y reembolse un préstamo</li></b>
            <ul>
                <li>Solicite un préstamo → obtenga 1 sorteo</li>
                <li>Paga 3 días antes → obtén 3 sorteos</li>
                <li>Paga con 2 días de anticipación → obtén ${ count } sorteos</li>
                <li>Paga con 1 día de anticipación → obtén 2 sorteos</li>
                <li>Pagar a tiempo → 1 sorteo</li>
            </ul>

            <b><li>Invitando amigos</li></b>
            <ul><li>amigos han llenado información → obtener 3 sorteos</li></ul>
        </ol>
    `,

    'noPrizeModelContent': (_class,link) => `
        <div className=${ _class }>
            <img src='${ link }/no-price.webp' alt="MIB" class="no-prize-img" style="width:150px;height:150px;position:relative;left:50%;transform:translateX(-50%)"/>
            <p class="no-prize-msg" style="text-align:center;font-weight:bold;font-size:0.5rem;">Ups！ Mala suerte</p>
            <p class="no-prize-msg" style="text-align:center">Será mejor la próxima vez</p>
        </div>
    `,
    'hasPrizeModelContent': (_class,awardId,HasLuckMsg,bgClass,prizeTypeMsg,award,activityEndDate,sign) => `
        <div className='${ _class }' id='l${ awardId }'>
            <p style="text-align:center;padding-top:0;word-break:break-word;">${ prizeTypeMsg }</p>
            <div className="name-img" style="
                background-image: url(${ bgClass });
                background-size:100% 100%;margin:0 auto;
            ">
                <div style="display:flex;">
                    <div style="width:1.5rem;margin-left:0;display:flex;justify-content: center;align-items: center;">
                        <p style="font-size:0.25rem;font-weight:normal;margin-top:0.369rem;margin-right:0.03rem;">${ sign }</p>
                        <p style="margin:0;font-size:0.5rem;">${ award.text }</p>
                    </div>
                    <div style="flex:1;display:flex;flex-direction:column;">
                        <p style="color:#0C0C0C;margin:0;font-size:0.2rem;line-height:0.25rem;padding-bottom:0.3rem;margin-top:0.26rem;font-weight:bold;word-wrap: break-word;">${ HasLuckMsg }</p>
                        <p style="color:#999999;margin:0;font-size:0.15rem;line-height:0;">Tiempo de expiración: ${ activityEndDate }</p>
                    </div>
                </div>
            </div>
        </div>
    `,

    'powerPrizeModelContent': (_class,awardId,powerAndCharge,prizeTypeMsg,w=2.8,h=1.15) => `
        <div className='${ _class }' id='l${ awardId }'>
            <p style="text-align:center;margin-top:0;word-break:break-word;">${ prizeTypeMsg }</p>
            <div className="name-img" style="
                width:${w}rem;
                height:${h}rem;
                background-image: url(${ powerAndCharge });
                background-size:100% 100%;margin:0 auto;
            ">
            </div>
        </div>
    `,

    'rulesMain': (activityDate,count) =>`
        <h3>Tiempo de actividad: <span>${ activityDate || '-' }</span></h3>

        <h3>¿Tengo la calificación?</h3>
        <p>Cualquier usuario que haya solicitado un préstamo es elegible para un préstamo, incluso aquellos que no lo hayan obtenido.</p>

        <h3>¿Cómo conseguir sorteos de la suerte?</h3>
        <ol>
            <b><li>Solicite y reembolse un préstamo</li></b>
            <ul>
                <li>Solicite un préstamo → obtenga 1 sorteo</li>
                <li>Paga 3 días antes → obtén 3 sorteos</li>
                <li>Paga con 2 días de anticipación → obtén ${ count } sorteos</li>
                <li>Paga con 1 día de anticipación → obtén 2 sorteos</li>
                <li>Pagar a tiempo → 1 sorteo</li>
            </ul>

            <b><li>Invitando amigos</li></b>
            <ul><li>amigos han llenado información → obtener 3 sorteos</li></ul>
        </ol>

        <h3>Período de vigencia del sorteo y cupón:</h3>
        <ol>
            <li>El sorteo solo es válido dentro del día en que lo recibas.</li>
            <li>El cupón es válido durante todo el período de actividad.</li>
        </ol>
        
        <h3>¿Cuándo recibiré el regalo?</h3>
        <ol>
            <li>El cupón se enviará a su cuenta en un plazo de 24 horas;</li>
            <li>El obsequio físico se enviará dentro de una semana y personal específico se comunicará con usted.</li>
        </ol>

        <h3>Declaración</h3>
        <p>El número de identificación de codificación / número de teléfono móvil / tarjeta de identidad se considera que es el mismo usuario.</p>
        <p>Si el usuario / comerciante viola las reglas (como transacción falsa, trampa, retiro de efectivo malicioso, etc.), tenemos derecho a limitar la cuenta de usuario, cancelar la transacción ilegal y obtener el premio;</p>
        <p>Las reglas y la configuración de premios de este gran plato giratorio cambiarán con el ajuste de la operación, y prevalecerá la visualización de la página específica.</p>
    `
}